"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsHighContrast = void 0;
const adaptivecards_1 = require("adaptivecards");
exports.TeamsHighContrast = new adaptivecards_1.HostConfig({
    choiceSetInputValueSeparator: ",",
    supportsInteractivity: true,
    spacing: {
        small: 8,
        default: 12,
        medium: 16,
        large: 20,
        extraLarge: 24,
        padding: 16,
    },
    separator: {
        lineThickness: 1,
        lineColor: "#EEEEEE",
    },
    fontTypes: {
        default: {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 14,
                large: 18,
                extraLarge: 24,
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600,
            },
        },
        monospace: {
            fontFamily: "'Courier New', Courier, monospace",
            fontSizes: {
                small: 12,
                default: 14,
                medium: 14,
                large: 18,
                extraLarge: 24,
            },
            fontWeights: {
                lighter: 200,
                default: 400,
                bolder: 600,
            },
        },
    },
    imageSizes: {
        small: 32,
        medium: 52,
        large: 100,
    },
    containerStyles: {
        default: {
            foregroundColors: {
                default: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                dark: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                light: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                accent: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                good: {
                    default: "#ff92c353",
                    subtle: "#e592c353",
                },
                warning: {
                    default: "#fff8d22a",
                    subtle: "#e5f8d22a",
                },
                attention: {
                    default: "#ffd74654",
                    subtle: "#e5d74654",
                },
            },
            backgroundColor: "#ff000000",
        },
        emphasis: {
            foregroundColors: {
                default: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                dark: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                light: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                accent: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                good: {
                    default: "#ff92c353",
                    subtle: "#e592c353",
                },
                warning: {
                    default: "#fff8d22a",
                    subtle: "#e5f8d22a",
                },
                attention: {
                    default: "#ffd74654",
                    subtle: "#e5d74654",
                },
            },
            backgroundColor: "#ff000000",
        },
        accent: {
            backgroundColor: "#C7DEF9",
            foregroundColors: {
                default: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                dark: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                light: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                accent: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                good: {
                    default: "#ff92c353",
                    subtle: "#e592c353",
                },
                warning: {
                    default: "#fff8d22a",
                    subtle: "#e5f8d22a",
                },
                attention: {
                    default: "#ffd74654",
                    subtle: "#e5d74654",
                },
            },
        },
        good: {
            backgroundColor: "#CCFFCC",
            foregroundColors: {
                default: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                dark: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                light: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                accent: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                good: {
                    default: "#ff92c353",
                    subtle: "#e592c353",
                },
                warning: {
                    default: "#fff8d22a",
                    subtle: "#e5f8d22a",
                },
                attention: {
                    default: "#ffd74654",
                    subtle: "#e5d74654",
                },
            },
        },
        attention: {
            backgroundColor: "#FFC5B2",
            foregroundColors: {
                default: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                dark: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                light: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                accent: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                good: {
                    default: "#ff92c353",
                    subtle: "#e592c353",
                },
                warning: {
                    default: "#fff8d22a",
                    subtle: "#e5f8d22a",
                },
                attention: {
                    default: "#ffd74654",
                    subtle: "#e5d74654",
                },
            },
        },
        warning: {
            backgroundColor: "#FFE2B2",
            foregroundColors: {
                default: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                dark: {
                    default: "#ff201f1f",
                    subtle: "#ff2d2c2c",
                },
                light: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                accent: {
                    default: "#ffffffff",
                    subtle: "#bfffffff",
                },
                good: {
                    default: "#ff92c353",
                    subtle: "#e592c353",
                },
                warning: {
                    default: "#fff8d22a",
                    subtle: "#e5f8d22a",
                },
                attention: {
                    default: "#ffd74654",
                    subtle: "#e5d74654",
                },
            },
        },
    },
    actions: {
        maxActions: 6,
        spacing: "Default",
        buttonSpacing: 8,
        showCard: {
            actionMode: "Inline",
            inlineTopMargin: 16,
            style: "emphasis",
        },
        preExpandSingleShowCardAction: false,
        actionsOrientation: "Horizontal",
        actionAlignment: "Left",
    },
    adaptiveCard: {
        allowCustomStyle: false,
    },
    imageSet: {
        imageSize: "Medium",
        maxImageHeight: 100,
    },
    factSet: {
        title: {
            size: "Default",
            color: "Default",
            isSubtle: false,
            weight: "Bolder",
            warp: true,
        },
        value: {
            size: "Default",
            color: "Default",
            isSubtle: false,
            weight: "Default",
            warp: true,
        },
        spacing: 16,
    },
});
//# sourceMappingURL=TeamsHighContrast.js.map